<template>
  <div ref="treeWrapper" class="query-builder">
    <query-builder-operator v-if="query"
      ref="operator" style="line-height: 2"
      :initial-query="query"
      :add-button-clicked="addButtonClicked"
      :remove-button-clicked="null"
      :on-query-change="onQueryChange"
      :readonly="readonly"/>
    <query-builder-tooltip
      ref="tooltip"/>
  </div>
</template>

<script script="ts">
import QueryBuilderOperator from "@/components/ProfileBuilder/QueryBuilderOperator";
import QueryBuilderTooltip from "@/components/ProfileBuilder/QueryBuilderTooltip";
import CvcqlBuilderIds from "@/helpers/CvcqlBuilderIds";

export default {
  name: "QueryBuilder",
  components: {QueryBuilderTooltip, QueryBuilderOperator},
  props: {
    initialQuery: {
      required: true,
    },
    onQueryChange: {
      type: Function,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      query: null,
    }
  },
  created() {
    if (this.initialQuery) {
      let initialOperatorKey = Object.keys(this.initialQuery)[0];
      let initialOperatorValue = Object.values(this.initialQuery)[0];
      if (initialOperatorKey !== CvcqlBuilderIds.and && initialOperatorKey !== CvcqlBuilderIds.or) {
        initialOperatorValue = [{[initialOperatorKey]: initialOperatorValue}];
        initialOperatorKey = 'and';
      }
      this.query = {[initialOperatorKey]: initialOperatorValue}
    } else {
      this.query = {and: []}
    }
  },
  methods: {
    addButtonClicked(addButton, addOperatorFunction) {
      this.$refs.tooltip.show(addButton, addOperatorFunction);
    },

    getQuery() {
      return this.$refs.operator.getQuery();
    },
    getLogicText() {
      let logicText = this.$refs.operator.getLogicText();
      if (logicText) {
        return logicText.substring(2, logicText.length - 2);
      } else {
        return '';
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  @import "src/styles/_mixins.scss";
  @import "src/styles/variables.scss";

  .query-builder {
    width: 100% !important;
  }
</style>